import { useQuery } from 'common/hooks';
import { getTeamObjectivesApi } from '../objectives.service';
import { ObjectiveResponse } from '../types/objective.type';

export const useGetTeamObjectives = () => {
  const queryResponse = useQuery(['team-objectives'], getTeamObjectivesApi, {
    select: (response) => ({
      ...response,
      data: response.data.objectives as ObjectiveResponse[],
    }),
  });

  return {
    ...queryResponse,
    data: queryResponse?.data?.data,
  };
};
